import { Modal } from 'react-bootstrap';
import { AiOutlineClose } from '@react-icons/all-files/ai/AiOutlineClose';
import './styles.scss';
import { useRichI18n } from 'Hooks/useRichI18n';
import { Typography } from 'Components/atoms';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Document as ContentfulDocument } from '@contentful/rich-text-types';

type MarkdownHelpModalProps = {
    show: boolean;
    onClose: () => void;
};

export const MarkdownHelpModal = ({ show, onClose }: MarkdownHelpModalProps) => {
    const { t, loading } = useRichI18n();

    const toRichDocument = (value: unknown): ContentfulDocument | null => {
        if (value && typeof value === 'object' && (value as ContentfulDocument).nodeType === 'document') {
            return value as ContentfulDocument;
        }
        return null;
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    const titleDocument = toRichDocument(t('ENGAGEMENT_HUB_MARKDOWN_FORMATTING_HELP_TITLE'));
    const descriptionDocument = toRichDocument(t('ENGAGEMENT_HUB_MARKDOWN_FORMATTING_HELP'));
    const title = titleDocument ? documentToReactComponents(titleDocument) : null;
    const description = descriptionDocument ? documentToReactComponents(descriptionDocument) : null;

    return (
        <Modal show={show} className="markdown-help-modal" onHide={onClose} centered>
            <Modal.Header>
                <Modal.Title>
                  {title}
                </Modal.Title>
                <AiOutlineClose
                    onClick={onClose}
                    className="close-icon"
                    data-testid="markdown-help-close-icon"
                    aria-label="Close Markdown Help Modal"
                />
            </Modal.Header>
            <Modal.Body className="custom-scrollbar">
            <Typography variant="subtitle3">
              {description}
            </Typography>
            </Modal.Body>
        </Modal>
    );
};

export default MarkdownHelpModal;

